export default {
  name: "backendmixin",
  emits:["sigcategoriesready","sigtagsready"],
  //opzionale
  
  /*
  data(){
    return {
          "isloading":false,
          "error":false,
          "errormessage":"",
          "baseaddress":"https://m5ohndu2q9.execute-api.eu-west-1.amazonaws.com/production",
          "s3address":"http://newlabwebsite.s3-website-eu-west-1.amazonaws.com"

    }
  },
  */

  data(){
    return {
          "isloading":false,
          "error":false,
          "errormessage":"",
          "baseaddress":"https://m5ohndu2q9.execute-api.eu-west-1.amazonaws.com/production",
          "s3address":"https://res.newlabelectronics.com"

    }
  },
  


  computed:{


    categories:{
      get(){
        return this.$store.state.categories;
      },
      set(newvalue){
        this.$store.commit("fnSetCategories",newvalue);
      }
    
    },


    tags:{
      get(){
        return this.$store.state.tags;
      },
      set(newvalue){
        this.$store.commit("fnSetTags",newvalue);
      }
    
    },


    cases:{
      get(){
        return this.$store.state.cases;
      },
      set(newvalue){
        this.$store.commit("fnSetCases",newvalue);
      }
    
    },

  },

  created(){
      

  },

  methods: {

      fnGetImageUrl(piImage)
      {
        return this.s3address+"/"+piImage;
      },


      fnResetStateBeforeFetch()
      {
        this.isloading=true;
        this.error=false;
        this.errormessage="";

      },

      fnSanitizeCategory(pikey)
      {
          let wfind=-1;
          let i=0;
          while ((i<this.categories.length) && (wfind==-1))
          {
            if (this.categories[i]["key"].toLowerCase() ==pikey)
            {
               wfind=i;
            }
            i++;
          }

          if (wfind==-1)
          {
            return "";
          }
          else
          {
            return pikey;
          }
      },

      fnFetchCategories()
      {
          //console.log("fnFetchCategories");
          this.fnResetStateBeforeFetch();

          this.categories=[];

          fetch(this.baseaddress+"/getcategories",{
              method:"GET",
              mode: "cors",
              headers:{
                "Content-Type":"application/json"
              }
          }).then(response =>{
            if (response.ok==true)
            {
              return(response.json());
            }
            else
            {
              this.isloading=false;
              this.error=true;
              this.errormessage=response.statusText;
              window.$mitter.emit("sigcategoriesready");
            }
          }).then(data => {
              //console.log(data);
              if (data.errormessage!="")
              {
                this.errormessage=data.errormessage;
                this.error=true;
              }
              else
              {
                this.error=false;
                this.errormessage="";

                let i=0;
                for(i=0;i<data.payload.length;i++)
                {
                  
                  this.categories.push(
                    {
                      "key":data.payload[i]["key"],
                      "title":data.payload[i]["title"][this.currentlang],
                      "slogan":data.payload[i]["slogan"][this.currentlang]
                    }
                  );
                }

                
              }
              
              this.isloading=false;

              window.$mitter.emit("sigcategoriesready");

          })
          .catch(error =>{
             this.isloading=false;
             this.error=true;
             this.errormessage=error;
             window.$mitter.emit("sigcategoriesready");
             
          });

      },




      fnSanitizeTag(pikey)
      {
          let wfind=-1;
          let i=0;
          while ((i<this.tags.length) && (wfind==-1))
          {
            if (this.tags[i]["key"].toLowerCase() ==pikey)
            {
               wfind=i;
            }
            i++;
          }

          if (wfind==-1)
          {
            return "";
          }
          else
          {
            return pikey;
          }
      },

      fnFetchTags()
      {
          //console.log("fnFetchCategories");
          this.fnResetStateBeforeFetch();

          this.tags=[];

          fetch(this.baseaddress+"/gettags",{
              method:"GET",
              mode: "cors",
              headers:{
                "Content-Type":"application/json"
              }
          }).then(response =>{
            if (response.ok==true)
            {
              return(response.json());
            }
            else
            {
              this.isloading=false;
              this.error=true;
              this.errormessage=response.statusText;
              window.$mitter.emit("sigtagsready");
            }
          }).then(data => {
              //console.log(data);
              if (data.errormessage!="")
              {
                this.errormessage=data.errormessage;
                this.error=true;
              }
              else
              {
                this.error=false;
                this.errormessage="";

                let i=0;
                for(i=0;i<data.payload.length;i++)
                {
                  
                  this.tags.push(
                    {
                      "key":data.payload[i]["key"],
                      "title":data.payload[i][this.currentlang]
                    }
                  );
                }

                
              }
              
              this.isloading=false;
              window.$mitter.emit("sigtagsready");

          })
          .catch(error =>{
             this.isloading=false;
             this.error=true;
             this.errormessage=error;
             window.$mitter.emit("sigtagsready");
          });

      },



      fnGetCategoryTranslation(pikey)
      {
        let wfind=-1;
        let i=0;
        while ((i<this.categories.length) && (wfind==-1))
        {
          if (wfind==-1)
          {
            if (this.categories[i]["key"]==pikey)
            {
              wfind=i;
            }
          }
          i++;
        }

        if (wfind==-1)
        {
          return "key not found "+pikey;
        }
        else
        {
          return this.categories[wfind]["title"];
        }

      },


      

      fnGetTagTranslation(pikey)
      {
        let wfind=-1;
        let i=0;
        while ((i<this.tags.length) && (wfind==-1))
        {
          if (wfind==-1)
          {
            if (this.tags[i]["key"]==pikey)
            {
              wfind=i;
            }
          }
          i++;
        }

        if (wfind==-1)
        {
          return "key not found "+pikey;
        }
        else
        {
          return this.tags[wfind]["title"];
        }

      },


      fnFetchCaseStudies(piFilter)
      {
          //console.log("fnFetchCategories");

          //console.log("filtro",piFilter);
          this.fnResetStateBeforeFetch();

          this.cases=[];

          let wquerystring="";

          if (piFilter.key!="")
          {
            wquerystring="?key="+piFilter.key;
          }
          else if ((piFilter.text!="") || (piFilter.category!="") || (piFilter.tag!=""))
          {
            wquerystring="?";
            
            if (piFilter.text!="")
            {
                wquerystring=wquerystring+"search="+piFilter.text;
            }

            if (piFilter.category!="")
            {
              if (wquerystring!="?")
              {
                wquerystring=wquerystring+"&";
              }
              wquerystring=wquerystring+"category="+piFilter.category;
            }

            if (piFilter.tag!="")
            {
              if (wquerystring!="?")
              {
                wquerystring=wquerystring+"&";
              }
              wquerystring=wquerystring+"tag="+piFilter.tag;
            }
            

          }


          if (piFilter.news==true)
          {
            if (wquerystring=="")
            {
              wquerystring="?";
            }
            if (wquerystring!="?")
            {
              wquerystring=wquerystring+"&";
            }
            wquerystring=wquerystring+"news=1";
          }


          //console.log("ricerco:",wquerystring);

          fetch(this.baseaddress+"/listcases"+wquerystring,{
              method:"GET",
              mode: "cors",
              headers:{
                "Content-Type":"application/json"
              }
          }).then(response =>{
            if (response.ok==true)
            {
              return(response.json());
            }
            else
            {
              this.isloading=false;
              this.error=true;
              this.errormessage=response.statusText;
              window.$mitter.emit("sigcasesready");
            }
          }).then(data => {
              //console.log(data);
              if (data.errormessage!="")
              {
                this.errormessage=data.errormessage;
                this.error=true;
              }
              else
              {
                this.error=false;
                this.errormessage="";

                let i=0;
                for(i=0;i<data.payload.length;i++)
                {
                  let witem={
                    "index":i,
                    "key":data.payload[i]["key"],
                    "category":this.fnGetCategoryTranslation(data.payload[i]["category"]),
                    "title":data.payload[i]["title"][this.currentlang],
                    "company":data.payload[i]["company"][this.currentlang],
                    "year":data.payload[i]["year"],
                    "description":data.payload[i]["description"][this.currentlang],
                    "tags":[],
                    "url":data.payload[i]["url"][this.currentlang],
                    "imageorder":data.payload[i]["imageorder"],
                    "sortindex":data.payload[i]["sortindex"],
                    "images":[],
                    "defaultimage":"",
                    "image1":"",
                    "image2":"",
                    "image3":"",
                    
                  };

                  let j=0;
                  for(j=0;j<data.payload[i]["tags"].length;j++)
                  {
                    witem["tags"].push(this.fnGetTagTranslation(data.payload[i]["tags"][j]));
                  }

                  for(j=0;j<data.payload[i]["images"].length;j++)
                  {
                    if (j==0)
                    {
                      witem["defaultimage"]=data.payload[i]["images"][j];
                    }
                    if (j==1)
                    {
                      witem["image1"]=data.payload[i]["images"][j];
                    }
                    if (j==2)
                    {
                      witem["image2"]=data.payload[i]["images"][j];
                    }
                    if (j==3)
                    {
                      witem["image3"]=data.payload[i]["images"][j];
                    }

                    witem["images"].push(data.payload[i]["images"][j]);
                  }

                  //console.log(witem);
                  this.cases.push(witem);
                }


                this.cases.sort(function(a, b) {
                  return b.sortindex.localeCompare(a.sortindex);
                });

                
              }
              
              this.isloading=false;
              window.$mitter.emit("sigcasesready");

          })
          .catch(error =>{
             this.isloading=false;
             this.error=true;
             this.errormessage=error;
             window.$mitter.emit("sigcasesready");
          });

      }









    }
}